import React, { useImperativeHandle, forwardRef, useState } from 'react';
import { validateInit, validateForm } from '@assets/js/util/formValidation.js';
import { formAtt } from '@assets/js/util/commonUtil.js';
import CompFmtSelectbox from '@components/form/fragment/comp-fmt-selectbox.js';
import {ApiSave} from '@assets/js/api/commonApi.js';

const CompFormMatchTrmntState = forwardRef((props, ref) => {
    const [params, setParams] = useState({});
    const [title] = useState('대진 상태 변경');

    /****************************
     * Define required variables
    *****************************/
    const rootId = 'modalSheetState';
    const validateOpt = {
        scopeEle: document.querySelector('#' + rootId),
        targetIds: ['mtmkgTycd', 'mtmkgStat'],
        params: params,
    }

    /*************************
     * Define react functions
    **************************/
    // Forward ref to allow parent components to call event functions.
    useImperativeHandle(ref, () => ({
        modalToggle(p_params) {
            openModal();
            handleToggle();
            
            const newParams = {...p_params};
            if (p_params && p_params.updateList && p_params.updateList.length === 1) {
                newParams.mtmkgTycd = p_params.updateList[0].mtmkgTycd;
                newParams.mtmkgStat = p_params.updateList[0].mtmkgStat;
            }
            setParams(newParams);
        },
    }));

    /**********************
     * Define functions
    ***********************/
   const openModal = () => {
        // Reset form inputs and validation state
        validateInit(validateOpt);

        // Reset selectbox values
        const mtmkgTycdEle = validateOpt.scopeEle?.querySelector('#mtmkgTycd');
        const mtmkgStatEle = validateOpt.scopeEle?.querySelector('#mtmkgStat');
        if (mtmkgTycdEle) mtmkgTycdEle.value = '';
        if (mtmkgStatEle) mtmkgStatEle.value = '';
    }

    const handleToggle = () => {
        if (validateOpt.scopeEle) {
            validateOpt.scopeEle.style.display = validateOpt.scopeEle.style.display === 'none' ? 'block' : 'none';
        }
    }

    const onSave = () => {
        // Validate form inputs before saving
        if (!validateForm(validateOpt)) { return; }
        
        // Get current values from DOM elements
        const targetEle = document.querySelector('#' + rootId);
        const mtmkgTycdEle = targetEle?.querySelector('#mtmkgTycd');
        const mtmkgStatEle = targetEle?.querySelector('#mtmkgStat');

        const mtmkgTycdValue = mtmkgTycdEle ? mtmkgTycdEle.value : params.mtmkgTycd || '';
        const mtmkgStatValue = mtmkgStatEle ? mtmkgStatEle.value : params.mtmkgStat || '';

        // Update params with current values
        const saveParams = {
            ...params,
            mtmkgTycd: mtmkgTycdValue,
            mtmkgStat: mtmkgStatValue
        };

        // Fetch data from the server
        ApiSave('/sys/mtmkgmng/change/state', saveParams).then(res => {
            if (res && res.success) {
                // Close the modal after saving
                handleToggle();
                // Search for updated data
                props.onGridSearch();
            }
        });
    }

    /****************************
     * Define form config
    *****************************/
    const formObj = {
        mtmkgTycd : formAtt({id: 'mtmkgTycd', label: '대진타입', value: params['mtmkgTycd'] || '', required: true, classCol: 'col-6'}),
        mtmkgStat : formAtt({id: 'mtmkgStat', label: '대진상태', value: params['mtmkgStat'] || '', required: true, classCol: 'col-6'}),
    }

    return (
        <>
            <div
                className="modal modal-sheet p-1 py-md-5"
                style={{ display: 'none', backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
                tabIndex={-1}
                role="dialog"
                id={rootId}
            >
                <div className="modal-dialog modal-md">
                    <div className="modal-content rounded-4 shadow">
                        <div className="modal-header border-bottom-0">
                            <h1 className="modal-title fs-5">{title}</h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={handleToggle}
                            />
                        </div>
                        <div className="modal-body py-0">
                            <div className="row g-5">
                                <div className="col-lg-12">
                                    <form className="needs-validation" noValidate="">
                                        <div className="row">
                                            {/* Display info */}
                                            <div className="col-12">
                                                <div className="alert alert-info" role="alert">
                                                    <strong>대회명:</strong> {params.comptnNm}
                                                </div>
                                            </div>

                                            {/* State change fields */}
                                            <CompFmtSelectbox
                                                attrs={formObj.mtmkgTycd}
                                                grpCd={"GRP008"}
                                                selectType={"S"}
                                                onChange={(e) => {
                                                    const { id, value } = e.target;
                                                    setParams({ ...params, [id]: value });
                                                    validateForm(validateOpt, id);
                                                }}
                                            />
                                            <CompFmtSelectbox
                                                attrs={formObj.mtmkgStat}
                                                grpCd={"GRP007"}
                                                selectType={"S"}
                                                onChange={(e) => {
                                                    const { id, value } = e.target;
                                                    setParams({ ...params, [id]: value });
                                                    validateForm(validateOpt, id);
                                                }}
                                            />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer flex-column align-items-stretch w-100 gap-2 pb-3 border-top-0">
                            <div className="btn-group">
                                <button type="button" className="btn btn-lg btn-primary" onClick={onSave}>
                                    Save changes
                                </button>
                                <button type="button" className="btn btn-lg btn-secondary" data-bs-dismiss="modal" onClick={handleToggle}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
});

export default CompFormMatchTrmntState;
